import { render, staticRenderFns } from "./TableSubscriptionPc.vue?vue&type=template&id=b72faae8&"
import script from "./TableSubscriptionPc.vue?vue&type=script&lang=js&"
export * from "./TableSubscriptionPc.vue?vue&type=script&lang=js&"
import style0 from "./TableSubscriptionPc.vue?vue&type=style&index=0&id=b72faae8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports